import { AppState } from "../../../redux-configuration/AppState";

export const isEditInstantLoadingSelector = (state: AppState): boolean => state.managementInstant.editInstant.isLoading
export const successEditInstantSelector = (state: AppState): boolean | null => state.managementInstant.editInstant.success
export const errorEditInstantSelector = (state: AppState): string | undefined => state.managementInstant.editInstant.error